var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceRemoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 20 20",
    id: "svg6098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6102"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 12.847175,3.8126494 C 12.056796,3.8333152 11.270949,3.9407778 10.506877,4.1453708 6.5612241,5.2025874 3.6889892,8.5899903 3.3135678,12.628782 3.6889936,8.5899903 6.5612241,5.2025874 10.506877,4.1453708 11.270947,3.9407782 12.056802,3.8286655 12.847175,3.8126494 Z",
    style: {
      clipRule: "evenodd",
      fill: "gray",
      fillRule: "evenodd",
      stroke: "#3F3F3F",
      strokeWidth: 0.61421096,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    id: "path3779-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.855933,6.2472917 C 12.373952,6.2679576 11.895989,6.3433882 11.430092,6.4694503 8.6265526,7.2205012 6.6108071,9.6828975 6.4067682,12.605317 6.6108038,9.6828975 8.6265526,7.2206049 11.430092,6.4694503 11.895989,6.3444215 12.373947,6.2700242 12.855933,6.2472917 Z",
    style: {
      clipRule: "evenodd",
      fill: "#3F3F3F",
      fillRule: "evenodd",
      stroke: "#3F3F3F",
      strokeWidth: 0.61421096,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      strokeDasharray: "none",
      strokeOpacity: 1,
      shapeRendering: "geometricPrecision"
    },
    id: "path3783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.972025,10.734761 v 6.868429 h 6.868431 V 10.734761 Z M 10.113472,9.4469308 h 8.585538 c 0.237083,0 0.429276,0.192194 0.429276,0.4292773 v 8.5855369 c 0,0.237083 -0.192193,0.429277 -0.429276,0.429277 h -8.585538 c -0.237084,0 -0.4292772,-0.192194 -0.4292772,-0.429277 V 9.8762081 c 0,-0.2370833 0.1921932,-0.4292773 0.4292772,-0.4292773 z m 5.866436,4.7289142 c 0.08253,0.04579 0.129518,0.116767 0.140984,0.212921 0.01147,0.09616 -0.01721,0.178579 -0.08597,0.247264 l -2.152587,2.033054 c -0.05044,0.05036 -0.11462,0.07556 -0.192563,0.07556 -0.10087,0 -0.179956,-0.04349 -0.237266,-0.130505 -0.05731,-0.087 -0.06762,-0.176289 -0.03096,-0.267869 l 0.618965,-1.483579 -1.210399,-0.700579 c -0.07794,-0.04579 -0.123797,-0.116767 -0.137546,-0.212921 -0.01375,-0.09616 0.01375,-0.178579 0.08252,-0.247264 l 2.152587,-2.033054 c 0.05961,-0.05036 0.123797,-0.07554 0.192564,-0.07554 0.07794,0 0.145568,0.02861 0.202878,0.08585 0.05731,0.05724 0.08596,0.12477 0.08596,0.202617 0,0.04579 -0.0092,0.087 -0.0275,0.123636 l -0.612077,1.469843 z",
    id: "path6096",
    style: {
      fill: "#3F3F3F",
      strokeWidth: 0.78700769,
      shapeRendering: "geometricPrecision"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceRemoteIcon);
export default __webpack_public_path__ + "static/media/device-remote-icon.ae660e6e5708b50f08046cdd36f5db88.svg";
export { ForwardRef as ReactComponent };